import { TypedEvent } from "../../typed_event";
import { Toner } from "../../models/toner/toners";
import { TonerJsEnv } from "../../models/toner/toner_js_env";
import { TonerRepository } from "../../repositories/toner/toner_repository";
import { TonerContainer } from "../../views/pc/toner/toner_container";

const SEARCH_TYPE_MAKER = "1";
const SEARCH_TYPE_PRINTER_TYPE = "2";
const SEARCH_TYPE_PRINTER_MODEL = "3";
const PARAMS = new URLSearchParams(window.location.search);
const PARAM_PRINTER_MAKER = PARAMS.get('printerMaker');
const PARAM_PRINTER_TYPE = Number(PARAMS.get('printerType'));
const PARAM_PRINTER_MODEL = PARAMS.get('printerModel');

export class TonerAction {
  static readonly UPDATE_EVENT = new TypedEvent<TonerJsEnv>();
  private static state: Toner;
  private static tonerRepository: TonerRepository;
  static async init() {
    this.tonerRepository = new TonerRepository();
    this.state = new Toner(await this.tonerRepository.getPrinterMakers(SEARCH_TYPE_MAKER));
    new TonerContainer(this.state.getModel()); // NOSONAR

    if (PARAM_PRINTER_MAKER !== null && PARAM_PRINTER_MAKER !== '' && PARAM_PRINTER_TYPE !== 0) {
      const printerTypePullDownModel = await this.tonerRepository.getPrinterTypes(SEARCH_TYPE_PRINTER_TYPE, PARAM_PRINTER_MAKER);
      const printerModelPullDownModel = await this.tonerRepository.getPrinterModels(SEARCH_TYPE_PRINTER_MODEL, PARAM_PRINTER_MAKER, PARAM_PRINTER_TYPE);
      this.state.updateModel(printerTypePullDownModel, printerModelPullDownModel, PARAM_PRINTER_MAKER, PARAM_PRINTER_TYPE, String(PARAM_PRINTER_MODEL));
      this.UPDATE_EVENT.trigger(this.state.getModel());
    }
  }

  static async drillDown(searchType: string, printerMaker: string, printerType: number | null) {
    if (searchType === SEARCH_TYPE_PRINTER_TYPE) {
      if (printerMaker === '') {
        this.state.clearPrinterTypes(printerMaker);
      } else {
        const model = await this.tonerRepository.getPrinterTypes(searchType, printerMaker);
        this.state.updatePrinterTypes(model, printerMaker);
      }
    } else {
      if (printerType === null || printerType === 0) {
        this.state.clearPrinterModels(printerType);
      } else {
        const model = await this.tonerRepository.getPrinterModels(searchType, printerMaker, printerType);
        this.state.updatePrinterModels(model, printerType);
      }
    }

    this.UPDATE_EVENT.trigger(this.state.getModel());
  }

  static updateSelectedPrinterModel(printerModel: string) {
    this.state.updatePrinterModel(printerModel);
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }
}
